import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';

class IsPropertyLandlord implements Rule {
  private index: number;

  get dependsOn(): string[] {
    return [`principals[${this.index}].relationship`];
  }

  public setIndex(index: number): IsPropertyLandlord {
    this.index = index;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    return (
      application.principals?.[this.index]?.['relationship'] ===
      RELATED_PARTY_RELATIONSHIP.LANDLORD
    );
  }
}

export default new IsPropertyLandlord();
